import { EWorldMapSetType } from '__generated__/globalTypes';
import { FilterList } from 'components/site/modals/FilterModal/FilterList';
import { SidebarDefaultFooter } from 'components/site/modals/SidebarModalWrapper/SidebarDefaultFooter';
import { SidebarModalWrapper } from 'components/site/modals/SidebarModalWrapper/SidebarModalWrapper';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';
import { CtxView } from 'session/ctxView';
import { Localization } from 'static/localization/localization';

export const FilterModal = (): JSX.Element => {
    const ctxModal = useContext(CtxModal);
    const ctxView = useContext(CtxView);

    const categories = (ctxView.map?.worldMapSets ?? []).filter(
        (e) => e.type === EWorldMapSetType.CATEGORY
    );
    const categoryIds = categories.map((e) => e.worldMapSetId);

    const showAllCategories = () => {
        ctxView.setVisibleMapSetIds([...ctxView.visibleMapSetIds, ...categoryIds]);
    };

    const hideAllCategories = () => {
        ctxView.setVisibleMapSetIds(
            ctxView.visibleMapSetIds.filter((e) => !categoryIds.includes(e))
        );
    };

    const onClose = () => {
        ctxModal.setShowFilters(false);
    };

    const content = <FilterList />;

    const footer = (
        <SidebarDefaultFooter
            buttons={[
                {
                    iconName: 'eye',
                    text: Localization.SHOW_ALL,
                    onClick: showAllCategories
                },
                {
                    iconName: 'eye-slash',
                    text: Localization.HIDE_ALL,
                    onClick: hideAllCategories
                },
                {
                    iconName: 'xmark',
                    text: Localization.CLOSE,
                    onClick: onClose
                }
            ]}
        />
    );

    return (
        <SidebarModalWrapper
            content={content}
            footer={footer}
            onClose={onClose}
            background={'#f1f1f1'}
        />
    );
};
